import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { MaquinaMovilService } from './entity-maquinas-moviles.service';
import {
  entityMaquinaMovilAddFailure,
  entityMaquinaMovilAddRequest,
  entityMaquinaMovilAddSuccess,
  entityMaquinaMovilDeleteFailure,
  entityMaquinaMovilDeleteRequest,
  entityMaquinaMovilDeleteSuccess,
  entityMaquinaMovilLoadFailure,
  entityMaquinaMovilLoadRequest,
  entityMaquinaMovilLoadSuccess,
  entityMaquinaMovilUpdateFailure,
  entityMaquinaMovilUpdateRequest,
  entityMaquinaMovilUpdateSuccess
} from './entity-maquinas-moviles.actions';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { NotificationService } from '../../../core/core.module';

@Injectable()
export class EntityMaquinasMovilesEffects {
  constructor(
    private actions$: Actions,
    private maquinaMovilService: MaquinaMovilService,
    private notificationService: NotificationService
  ) {}

  loadRequestMaquinaMovil = createEffect(() =>
    this.actions$.pipe(
      ofType(entityMaquinaMovilLoadRequest),
      mergeMap(() =>
        this.maquinaMovilService.getMaquinasMoviles().pipe(
          map((items) => entityMaquinaMovilLoadSuccess({ items })),
          catchError((error) => of(entityMaquinaMovilLoadFailure({ error })))
        )
      )
    )
  );

  addRequestMaquinaMovil = createEffect(() =>
    this.actions$.pipe(
      ofType(entityMaquinaMovilAddRequest),
      mergeMap((action) =>
        this.maquinaMovilService.addMaquinasMoviles(action.item).pipe(
          map((item) => entityMaquinaMovilAddSuccess({ item })),
          catchError((error) => of(entityMaquinaMovilAddFailure({ error })))
        )
      )
    )
  );

  updateRequestMaquinaMovil = createEffect(() =>
    this.actions$.pipe(
      ofType(entityMaquinaMovilUpdateRequest),
      mergeMap((action) =>
        this.maquinaMovilService.updateMaquinasMoviles(action.item).pipe(
          map((item) => entityMaquinaMovilUpdateSuccess({ item: action.item })),
          catchError((error) => of(entityMaquinaMovilUpdateFailure({ error })))
        )
      )
    )
  );

  deleteRequestMaquinaMovil = createEffect(() =>
    this.actions$.pipe(
      ofType(entityMaquinaMovilDeleteRequest),
      mergeMap((action) =>
        this.maquinaMovilService.deleteMaquinasMoviles(action.item).pipe(
          map((item) => {
            this.notificationService.success(
              'Máquina móvil eliminada correctamente.'
            );
            return entityMaquinaMovilDeleteSuccess({ item: action.item });
          }),
          catchError((error) => of(entityMaquinaMovilDeleteFailure({ error })))
        )
      )
    )
  );

  addRequestMaquinaMovilSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityMaquinaMovilAddSuccess),
        tap(() =>
          this.notificationService.success(
            'Máquina móvil registrada correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  addRequestMaquinaMovilFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityMaquinaMovilAddFailure),
        tap(() =>
          this.notificationService.error('Error al registrar máquina móvil.')
        )
      ),
    { dispatch: false }
  );

  updateRequestMaquinaMovilSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityMaquinaMovilUpdateSuccess),
        tap(() =>
          this.notificationService.success(
            'Máquina móvil actualizada correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  updateRequestMaquinaMovilFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityMaquinaMovilUpdateFailure),
        tap(() =>
          this.notificationService.error('Error al actualizar máquina móvil.')
        )
      ),
    { dispatch: false }
  );

  loadRequestMaquinaMovilSuccess = createEffect(
    () => this.actions$.pipe(ofType(entityMaquinaMovilLoadSuccess)),
    { dispatch: false }
  );

  loadRequestMaquinaMovilFailure = createEffect(
    () => this.actions$.pipe(ofType(entityMaquinaMovilLoadFailure)),
    { dispatch: false }
  );

  deleteRequestMaquinaMovilSuccess = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityMaquinaMovilDeleteSuccess),
        tap(() =>
          this.notificationService.success(
            'Máquina móvil eliminada correctamente.'
          )
        )
      ),
    { dispatch: false }
  );

  deleteRequestMaquinaMovilFailure = createEffect(
    () =>
      this.actions$.pipe(
        ofType(entityMaquinaMovilDeleteFailure),
        tap(() =>
          this.notificationService.error('Error al eliminar máquina móvil.')
        )
      ),
    { dispatch: false }
  );
}
